<template>
  <v-list-item
    v-if="option.show !== false"
    :to="option.link"
    @click.stop="resolveAction"
  >
    <template #prepend>
      <v-icon :color="option.class">{{ option.icon }}</v-icon>
    </template>
    <template #default>
      <v-list-item-title :class="option.class + '--text'">{{
        option.name
      }}</v-list-item-title>
    </template>
  </v-list-item>
</template>

<script>
export default {
  name: "ContextMenuOption",
  props: ["option"],
  emits: ["action-executed"],
  methods: {
    resolveAction() {
      if (this.option.action) {
        this.option.action();
        this.$emit("action-executed");
      }
    },
  },
};
</script>
